/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { LabelReasonsData } from "./LabelReasonsData"
import type { WorkflowSimulationReport } from "./WorkflowSimulationReport"

/**
 * An Abstract class representing the common fields of all insights responses.
 */
export type LabelReasonsInsight = {
  uuid: string
  created_at: string
  /**
   * * `FEATURES_COUNTS` - Features
   * * `FEATURES_CATEGORIES` - Features Categories
   * * `LABEL` - Label
   * * `LABEL_REASON` - Label Reason
   * * `PREDICTIONS_PER_WORKFLOW` - Predictions Per Workflow
   * * `PREDICTIONS_PER_MODEL` - Predictions Per Model
   * * `FEATURE_COMPARISON` - Feature Comparison
   * * `FEATURES_PROFILING` - Features Profiling
   * * `FEATURE_CORRELATION` - Feature Correlation
   * * `LABEL_TIME_COUNT` - Label Time Counts
   * * `WORKFLOW_NODE_PERCENTAGES` - Workflow Node Percentages
   * * `FEEDBACK_COUNT` - Feedback Count
   * * `FEEDBACKS_PER_WORKFLOW_MODEL` - Feedbacks Per Workflow or Model
   * * `FEEDBACK_CORRELATION` - Feedback Correlation
   * * `FEEDBACK_PROFILE` - Feedback Profile
   * * `FEEDBACK_PER_LABEL_AND_REASON` - Feedback Per Label And Reason
   * * `LEGACY_SIMULATION_REPORT` - Legacy Simulation
   */
  type: LabelReasonsInsight.insight_type

  status: string
  /**
   * How many entries the insight considered
   */
  count?: number | null
} & (
  | {
      version: "V0"
      data: {
        report: WorkflowSimulationReport
        simulation_job: {
          uuid: string
          status: string
          version: number
          workflow: string
          created_at: string
          created_by: string
          report_status: string
          target_column: string
          workflow_name: string
          failure_reason: string | null
          predictions_datafile: string
          report_failure_reason: string | null
          predictions_datafile_name: string
        }
        total_failed: number
        total_requests: number

        skip_reason: string | null
      }
    }
  | {
      version: "V1"
      data: Record<string, LabelReasonsData>
    }
)

export namespace LabelReasonsInsight {
  /**
   * * `FEATURES_COUNTS` - Features
   * * `FEATURES_CATEGORIES` - Features Categories
   * * `LABEL` - Label
   * * `LABEL_REASON` - Label Reason
   * * `PREDICTIONS_PER_WORKFLOW` - Predictions Per Workflow
   * * `PREDICTIONS_PER_MODEL` - Predictions Per Model
   * * `FEATURE_COMPARISON` - Feature Comparison
   * * `FEATURES_PROFILING` - Features Profiling
   * * `FEATURE_CORRELATION` - Feature Correlation
   * * `LABEL_TIME_COUNT` - Label Time Counts
   * * `WORKFLOW_NODE_PERCENTAGES` - Workflow Node Percentages
   * * `FEEDBACK_COUNT` - Feedback Count
   * * `FEEDBACKS_PER_WORKFLOW_MODEL` - Feedbacks Per Workflow or Model
   * * `FEEDBACK_CORRELATION` - Feedback Correlation
   * * `FEEDBACK_PROFILE` - Feedback Profile
   * * `FEEDBACK_PER_LABEL_AND_REASON` - Feedback Per Label And Reason
   * * `LEGACY_SIMULATION_REPORT` - Legacy Simulation
   */
  export enum insight_type {
    FEATURES_COUNTS = "FEATURES_COUNTS",
    FEATURES_CATEGORIES = "FEATURES_CATEGORIES",
    LABEL = "LABEL",
    LABEL_REASON = "LABEL_REASON",
    PREDICTIONS_PER_WORKFLOW = "PREDICTIONS_PER_WORKFLOW",
    PREDICTIONS_PER_MODEL = "PREDICTIONS_PER_MODEL",
    FEATURE_COMPARISON = "FEATURE_COMPARISON",
    FEATURES_PROFILING = "FEATURES_PROFILING",
    FEATURE_CORRELATION = "FEATURE_CORRELATION",
    LABEL_TIME_COUNT = "LABEL_TIME_COUNT",
    WORKFLOW_NODE_PERCENTAGES = "WORKFLOW_NODE_PERCENTAGES",
    FEEDBACK_COUNT = "FEEDBACK_COUNT",
    FEEDBACKS_PER_WORKFLOW_MODEL = "FEEDBACKS_PER_WORKFLOW_MODEL",
    FEEDBACK_CORRELATION = "FEEDBACK_CORRELATION",
    FEEDBACK_PROFILE = "FEEDBACK_PROFILE",
    FEEDBACK_PER_LABEL_AND_REASON = "FEEDBACK_PER_LABEL_AND_REASON",
    LEGACY_SIMULATION_REPORT = "LEGACY_SIMULATION_REPORT",
  }
}
